import { render } from "./ScheduleList.vue?vue&type=template&id=aef04dde"
import script from "./ScheduleList.vue?vue&type=script&lang=js"
export * from "./ScheduleList.vue?vue&type=script&lang=js"

import "./ScheduleList.vue?vue&type=style&index=0&id=aef04dde&lang=css"

import exportComponent from "D:\\react js\\VET_VUE\\VET-mini-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__